import { createFileRoute } from "@tanstack/react-router";
import { loadBlockPage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/vs-microsoft-entra-id-governance")({
  loader: async () => {
    const page = await loadBlockPage({ data: { collection: "sp", slug: "vs-microsoft-entra-id-governance" } });
    return page;
  },
  head: ({ loaderData }) => ({ meta: seo({ title: (loaderData as any)?.seo_title || (loaderData as any)?.title, description: (loaderData as any)?.seo_description, url: "/vs-microsoft-entra-id-governance" }), links: seoLinks({ url: "/vs-microsoft-entra-id-governance" }) }),
  component: () => { const p = Route.useLoaderData() as any; return <BlockRenderer blocks={p.blocks || []} />; },
});
